<!-- Meldungen Fenster -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    export let show_old_alarms;
    function toggleButton() {
        show_old_alarms = !show_old_alarms;
    }
</script>

<div class="display_box side-menu" style="justify-content:flex-start;">
    <p class="p-kachel" style="flex 0 0 10%;">
        {show_old_alarms ? "Alte Meldungen" : "Aktuelle Meldungen"}
    </p>

    <div style="flex: 1 1 50%;overflow-y:auto;" class="scroll_window mt-3 mb-3">
        <slot />
    </div>
    <div style="flex: 0 0 5%;">
    <div class="input-group" >
        <button
            on:click={toggleButton}
            id="switch_meldungen_btn"
            class="btn btn-primary btn-block"
            style="white-space: wrap;"
        >
            {show_old_alarms
                ? "Aktuelle Meldungen anzeigen"
                : "Alte Meldungen anzeigen"}
        </button>
    </div>
</div>
</div>
